import React from 'react';

import useDeviceType from '../providers/DeviceType/hooks';
import ComponentType from '../types/Component';

type MobileLayoutType = {};

const MobileLayout: ComponentType<MobileLayoutType> = ({ children }) => {
	const { isMobile } = useDeviceType();

	if (!isMobile) return null;

	return <>{children}</>;
};

export default MobileLayout;
